/** Event fields used for the Accounts Event column label. */
export type NiyaazReceiptEventLabelFields = {
  name?: string;
  hijriYear?: string;
};

/**
 * List-row input for {@link eventLabel}.
 * Accepts RaRecord rows and partial test fixtures (weak optional-only shapes).
 */
export type NiyaazReceiptEventLabelRecord = {
  event?: NiyaazReceiptEventLabelFields | null;
} & Record<string, unknown>;

/** Accounts remount has no event route id; Events nested list passes the event id. */
export function isAccountsNiyaazReceiptList(routeId: string | undefined | null): boolean {
  return !routeId;
}

export function eventLabel(record: NiyaazReceiptEventLabelRecord | null | undefined): string {
  const event = record?.event;
  if (!event?.name) return "—";
  return event.hijriYear ? `${event.name} (${event.hijriYear})` : event.name;
}

/** CSV / Datagrid include an Event column only on the Accounts remount. */
export function receiptListShowsEventColumn(routeId: string | undefined | null): boolean {
  return isAccountsNiyaazReceiptList(routeId);
}
